export const MAX_PINNED_CHATS_COUNT = 5

export const MAX_COMPANIES_COUNT = 9

export const CHAT_MESSAGES_PER_BUNCH = 50
export const MAX_MESSAGE_LENGTH = 8200
export const MAX_FILES_FOR_MESSAGE_COUNT = 10
